import { formatDistanceToNow, format, parseISO } from "date-fns";

export function relTime(iso) {
  if (!iso) return "—";
  try {
    const d = typeof iso === "string" ? parseISO(iso) : iso;
    return formatDistanceToNow(d, { addSuffix: true });
  } catch {
    return "—";
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = typeof iso === "string" ? parseISO(iso) : iso;
    return format(d, "yyyy-MM-dd HH:mm:ss");
  } catch {
    return "—";
  }
}

export function shortId(id) {
  if (!id) return "";
  const s = String(id);
  return s.length > 8 ? `${s.slice(0, 4)}…${s.slice(-4)}` : s;
}

export function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase() || "?";
}

export const MISSION_STAGE_KEYS = [
  "intake",
  "product",
  "design",
  "engineering",
  "qa",
  "security",
  "release",
  "production",
];

export const STATUS_TO_PILL = {
  draft: "amber",
  in_progress: "blue",
  in_review: "purple",
  blocked: "red",
  completed: "green",
  cancelled: "dim",
};

export function statusLabel(s) {
  if (!s) return "—";
  return s.replace(/_/g, " ");
}

export function priorityLabel(p) {
  return (p || "normal").toUpperCase();
}
